export default __webpack_public_path__ + "static/media/logo-color.4b795eac.jpg";